import DeleteModal from '../../../../Modals/DeleteModal';
import CustomTable from '../../../../../components/table/CustomTable';
import AccessFunctionality from '../Functionality/AccessFunctionality';
import { TrashOutlineIcon } from '../../../../../components/buttons/IconButtons';
import Subtitle from '../../../../../components/Header/Subtitle';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @returns {JSX.Element}
 * @constructor
 */
const Access = ({ id, modified, setModified }) => {
    const {
        tableId,
        searchId,
        thead,
        tbody,
        isAllChecked,
        selectedList,
        setSelectedList,
        setIsAllChecked,
        showDeleteModal,
        setShowDeleteModal,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedWorkShift,
        deletePermission
    } = AccessFunctionality({
        id,
        modified,
        setModified
    });
    return (
        <>
            <div className='d-flex align-items-center justify-content-between mt-4'>
                <Subtitle name={'schedules'} />

                {selectedList?.length > 0 && (
                    <ButtonAction
                        id='btn_a_delete'
                        name='delete'
                        className='btn-icon-delete'
                        Icon={TrashOutlineIcon}
                        onClick={() => setShowDeleteModal(true)}
                    />
                )}
            </div>

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={deletePermission}
                checkboxTitle={'de_/_select_all'}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                withoutHeight={true}
            />
            {pagination()}

            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onClickFn={() => deleteSelectedWorkShift(selectedList)}
                data={selectedList}
                title_modal={'workshift'}
                description={'are_you_sure_you_want_to_remove'}
                element_modal={'access'}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
            />
        </>
    );
};

export default Access;
